import { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import {
  CostBreakdownData,
  CostBreakdownDataType,
  DashboardSettings, Destination, RecentShipment, ScheduledPickup, Transits, WidgetSettings,
} from '@/features/dashboard/types';
import { defaultCostBreakdownData } from '@/features/common/raw';
import { PatchRequestType } from '@/features/settings/types';

const { axiosService } = useAxios();

export const getDashboardSettings = async (): Promise<DashboardSettings | null> => {
  try {
    const response: AxiosResponse = await axiosService.get('/dashboard/settings');
    return response.data;
  } catch {
    return null;
  }
};

export const syncDashboardSetting = async (
  settingsData: WidgetSettings,
): Promise<WidgetSettings | null> => {
  try {
    const response: AxiosResponse = await axiosService.post('/dashboard/setting', {
      ...settingsData,
    });
    return response.data;
  } catch {
    return null;
  }
};

export const patchDashboardSetting = async (
  patches: PatchRequestType[],
): Promise<WidgetSettings | null> => {
  try {
    const response: AxiosResponse = await axiosService.patch(
      '/dashboard/settings', patches,
    );
    return response.data;
  } catch (err) {
    return null;
  }
};

export const getTransitStatusData = async (): Promise<Transits | null> => {
  try {
    const response: AxiosResponse = await axiosService.get('/dashboard/transit-status');
    return response.data;
  } catch {
    return null;
  }
};

export const getRecentShipmentsData = async (
  limit: number,
  offset: number,
  isCreated = true,
  isInTransit = true,
  isDelivered = true,
  isException = true,
): Promise<Array<RecentShipment>> => {
  const url = `/dashboard/recent-shipments?Offset=${offset}&Limit=${limit}&Created=${isCreated}&Intransit=${isInTransit}&Exception=${isException}&Delivered=${isDelivered}&orderBy=Id&OrderByDescending=true`;

  try {
    const response: AxiosResponse = await axiosService.get(url);
    return response.data;
  } catch {
    return [];
  }
};

export const getScheduledPickupsData = async (
  limit: number,
  offset: number,
): Promise<Array<ScheduledPickup>> => {
  try {
    const url = `/dashboard/scheduled-pickups?Offset=${offset}&Limit=${limit}`;
    const response: AxiosResponse = await axiosService.get(url);
    return response.data;
  } catch {
    return [];
  }
};

export const getTopDestinationsData = async (
  fromDate: string,
  toDate: string,
  limit = 12,
  offset = 0,
): Promise<Array<Destination>> => {
  try {
    const response: AxiosResponse = await axiosService.get(
      `/dashboard/top-destination-countries?Offset=${offset}&Limit=${limit}&FromDate=${fromDate}&ToDate=${toDate}`,
    );
    return response.data;
  } catch {
    return [];
  }
};

export const getCostBreakdownData = async (
  fromDate: string,
  toDate: string,
  type: keyof typeof CostBreakdownDataType,
): Promise<CostBreakdownData> => {
  try {
    const resposne: AxiosResponse = await axiosService.get(
      `/dashboard/cost-breakdown/${fromDate}/${toDate}?type=${type}`,
    );

    return resposne.data;
  } catch {
    return defaultCostBreakdownData;
  }
};
